/* Decorative PDP images: reveal only successfully loaded images, including replacements. */
(() => {
  'use strict';
  const selector = '.igneous-related-gear__secondary-image';
  const update = (image) => {
    if (!(image instanceof HTMLImageElement) || !image.matches(selector)) return;
    image.toggleAttribute('data-related-image-ready', image.complete && image.naturalWidth > 0);
  };
  const scan = (node) => {
    if (!(node instanceof Element)) return;
    update(node);
    node.querySelectorAll(selector).forEach(update);
  };
  // A choice keeps its primary photo until the shopper deliberately returns to imagery.
  const bindIntent = (list) => {
    if (list.__igneousRelatedImageIntentBound) return;
    list.__igneousRelatedImageIntentBound = true;
    const itemFor = (node) => {
      if (!(node instanceof Element)) return null;
      const item = node.closest('li.igneous-related-gear__item');
      return item && item.parentElement === list ? item : null;
    };
    const inZone = (node, item, zone) => itemFor(node) === item && !!node.closest(zone);
    const variant = 'input[data-related-variant],select[data-related-variant]';
    const imagery = '.igneous-related-gear__photo';
    list.addEventListener('focusin', (event) => {
      const item = itemFor(event.target);
      if (!item) return;
      if (event.target.matches(variant)) item.setAttribute('data-related-primary-intent', '');
    });
    list.addEventListener('change', (event) => {
      const item = itemFor(event.target);
      if (item && event.target.matches(variant)) item.setAttribute('data-related-primary-intent', '');
    });
    const pointerIntent = (event) => {
      if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
      const item = itemFor(event.target);
      if (!item) return;
      if (inZone(event.target, item, '.igneous-related-gear__variants')) {
        item.setAttribute('data-related-primary-intent', '');
      } else if (inZone(event.target, item, imagery)) {
        const entered = event.type === 'pointerover' && !inZone(event.relatedTarget, item, imagery);
        const moved = event.type === 'pointermove' && Number.isFinite(event.movementX) && Number.isFinite(event.movementY) && (event.movementX !== 0 || event.movementY !== 0);
        if (entered || moved) item.removeAttribute('data-related-primary-intent');
      }
    };
    list.addEventListener('pointerover', pointerIntent);
    list.addEventListener('pointermove', pointerIntent);
  };
  const initialize = () => document.querySelectorAll('.igneous-related-gear__list').forEach((list) => {
    bindIntent(list);
    if (list.hasAttribute('data-related-images-observed')) return;
    list.setAttribute('data-related-images-observed', '');
    list.addEventListener('load', (event) => update(event.target), true);
    list.addEventListener('error', (event) => update(event.target), true);
    scan(list);
    new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach(scan)))
      .observe(list, { childList: true, subtree: true });
  });
  initialize();
  ['theme:section:load', 'theme:section:update'].forEach((name) => {
    window.addEventListener(name, initialize);
  });
  document.addEventListener('shopify:section:load', initialize);
})();
